import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: ${props => (props.disabled || props.back) ? '#D7D7D7' : props.theme.buttonBgColorNormal || '#00AEEF'};
  color: ${props => (props.disabled || props.back) ? '#333' : '#fff'};
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 16px;
  width: ${props => props.width ? props.width : '100%'};
  height: 33.75px;
  margin: 1em;
  font-size: 13.6px;
  ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);

  &:hover {
    background-color: ${props => (props.disabled || props.back) ? '#C2C2C2' : props.theme.buttonBgColorHover || '#0094CB'};
  }
`;

const Button = ({ marginLeft, width, text, callback, disabled, back }) => {
    return (
        <StyledButton marginLeft={marginLeft} width={width} onClick={callback} disabled={disabled} back={back}>
            {text}
        </StyledButton>
    );
};

export default Button;
